import { render, staticRenderFns } from "./service_dynamic.vue?vue&type=template&id=28380f96&scoped=true"
import script from "./service_dynamic.vue?vue&type=script&lang=js"
export * from "./service_dynamic.vue?vue&type=script&lang=js"
import style0 from "./service_dynamic.vue?vue&type=style&index=0&id=28380f96&prod&lang=scss"
import style1 from "./service_dynamic.vue?vue&type=style&index=1&id=28380f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28380f96",
  null
  
)

export default component.exports